// "A, B and C" in the reader's language. Hermes builds may ship without
// Intl.ListFormat (RN's Intl differs by Hermes version, parseLocaleNumber.ts):
// a comma list is the fallback, not a crash. Typed here because the mobile
// tsconfig lib does not declare it.
type ListFormatCtor = new (
  locale: string,
  opts: { style: "long"; type: "conjunction" },
) => { format: (items: string[]) => string };
const ListFormat = (Intl as unknown as { ListFormat?: ListFormatCtor })
  .ListFormat;

export const joinList = (items: string[], locale: string): string =>
  ListFormat
    ? new ListFormat(locale, { style: "long", type: "conjunction" }).format(items)
    : items.join(", ");
